const imageWithTextSections = document?.querySelectorAll(
  ".image-with-text-section"
);

imageWithTextSections?.forEach((section) => {
  const accordionItems = section?.querySelectorAll(".accordion-el");

  accordionItems?.forEach((item) => {
    const accordionHeader = item?.querySelector(".accordion-header");
    accordionHeader?.addEventListener("click", function (e) {
      const image = item?.dataset?.image;
      const imageUrl = window?.location?.origin?.includes("127.0.0.1:9292")
        ? `${window?.location?.origin}${image}`
        : image;

      const currentImage = section?.querySelector(
        ".image-with-text__media img"
      );
      accordionItems?.forEach((el) => {
        el?.classList?.remove("active");
      });
      if (image && currentImage) {
        currentImage.srcset = imageUrl;
        currentImage.src = imageUrl;
      }

      item?.classList?.toggle("active");
    });
  });
});
